import { Grid, Stack, Button, Typography } from '@mui/material';
import InfoGrid from 'src/components/ui-kit/info-grid';
import { useBoolean } from 'src/hooks/use-boolean';
import { UserType, UserVerificationStatus } from 'src/type/user';
import ImageWithPreview from 'src/components/ui-kit/image-with-preview';
import PrivateImage from 'src/components/ui-kit/private-image';
import UserEditRejectDialog from './user-edit-reject-dialog';
import UserEditApproveDialog from './user-edit-approve-dialog';

type Props = {
  user: UserType;
  handleReload: VoidFunction;
};

export default function UserEditVerification({ user, handleReload }: Props) {
  const approving = useBoolean(false);
  const rejecting = useBoolean(false);

  const { userWallet, approvedByUser } = user;
  const {
    accountName,
    accountNumber,
    bank,
    bankImageUrl,
    bookBankImageUrl,
    firstName,
    lastName,
    address,
    idCardNumber,
    idCardImageUrl,
  } = userWallet || {};

  const infos = [
    ...(approvedByUser
      ? [
          {
            label: `ยืนยันโดย`,
            value: `${approvedByUser?.firstName} ${approvedByUser?.lastName}`,
          },
        ]
      : []),
    {
      label: 'รูปภาพอัพโหลด',
      value: idCardImageUrl ? (
        <PrivateImage
          uid={user.uid}
          folder="idCards"
          filename={idCardImageUrl}
          alt=""
          sx={{ width: 150, height: 150 }}
          disableRightClick
        />
      ) : (
        '-'
      ),
    },
    {
      label: 'ชื่อ (ตามบัตรประชาชน)',
      value: firstName || '-',
    },
    {
      label: 'นามสกุล (ตามบัตรประชาชน)',
      value: lastName || '-',
    },
    {
      label: 'ที่อยู่ (ตามบัตรประชาชน)',
      value: address || '-',
    },
    {
      label: 'เลขประจำตัวประชาชน',
      value: idCardNumber || '-',
    },
    {
      label: `ธนาคาร`,
      value: bank?.name || '-',
    },
    {
      label: `เลขบัญชีธนาคาร`,
      value: accountNumber || '-',
    },
    {
      label: `ชื่อบัญชีธนาคาร`,
      value: accountName || '-',
    },
    {
      label: 'รูปธนาคาร',
      value: bankImageUrl ? (
        <ImageWithPreview src={bankImageUrl} alt="" sx={{ width: 150, height: 150 }} />
      ) : (
        '-'
      ),
    },
    {
      label: 'รูปหน้าบัญชีธนาคาร',
      value: bookBankImageUrl ? (
        <PrivateImage
          uid={user.uid}
          folder="bookBanks"
          filename={bookBankImageUrl}
          alt=""
          sx={{ width: 150, height: 150 }}
          disableRightClick
        />
      ) : (
        '-'
      ),
    },
  ];

  return (
    <>
      <Stack spacing={4}>
        <Typography variant="h6">การยืนยันตัวตน</Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            {user.verifyStatus === UserVerificationStatus.PROCESSING && <InfoGrid infos={infos} />}

            {[UserVerificationStatus.PENDING, UserVerificationStatus.PROCESSING].includes(
              user.verifyStatus!
            ) && (
              <Stack direction="row" spacing={2}>
                <Button
                  variant="contained"
                  color="warning"
                  onClick={approving.onTrue}
                  disabled={user.verifyStatus === UserVerificationStatus.PENDING}
                >
                  อนุมัติการยืนยันตัวตน
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={rejecting.onTrue}
                  disabled={user.verifyStatus === UserVerificationStatus.PENDING}
                >
                  ปฏิเสธการยืนยันตัวตน
                </Button>
              </Stack>
            )}
          </Grid>
        </Grid>
      </Stack>
      <UserEditApproveDialog
        open={approving.value}
        onClose={approving.onFalse}
        user={user}
        handleReload={handleReload}
      />
      <UserEditRejectDialog
        open={rejecting.value}
        onClose={rejecting.onFalse}
        user={user}
        handleReload={handleReload}
      />
    </>
  );
}
